const configs = {
  api: process.env.REACT_APP_API_SERVICE,
  app: process.env.REACT_APP_APP_SERVICE,
  ga_mesuarement: process.env.REACT_APP_GA_MEASUREMENT,
  conductor: process.env.REACT_APP_URL_TAKEME
};

export default configs;
